/* Tenkara Cast — audio player, episode list, transcript.
   One shared <audio> element drives every control on the page:
   - <podcast-player>  the large player on an episode page
   - [data-pc-play]    play buttons on episode lists ("Play latest", list rows)
   - <podcast-bar>     a sticky mini-player that appears while audio plays
   - [data-pc-seek]    chapter links and transcript timestamps
   Listening position is remembered per episode (localStorage, best effort). */
(function () {
  if (window.TenkaraCast) return;

  var SPEEDS = [1, 1.25, 1.5, 1.75, 2];
  var store = {
    get: function (k) { try { return JSON.parse(localStorage.getItem(k)); } catch (e) { return null; } },
    set: function (k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  };

  function clock(sec) {
    sec = Math.max(0, Math.floor(sec || 0));
    var h = Math.floor(sec / 3600), m = Math.floor((sec % 3600) / 60), s = sec % 60;
    var ss = (s < 10 ? '0' : '') + s;
    if (h) return h + ':' + (m < 10 ? '0' : '') + m + ':' + ss;
    return m + ':' + ss;
  }
  function parseTime(v) {
    if (!v) return 0;
    if (/^\d+$/.test(v)) return parseInt(v, 10);
    if (/^\d+(:\d+){1,2}$/.test(v)) return v.split(':').reduce(function (a, b) { return a * 60 + parseInt(b, 10); }, 0);
    var m = String(v).match(/(?:(\d+)h)?(?:(\d+)m)?(?:(\d+)s)?/);
    return m ? (+(m[1] || 0)) * 3600 + (+(m[2] || 0)) * 60 + (+(m[3] || 0)) : 0;
  }
  function posKey(src) { return 'tc:pos:' + src; }

  /* ---------- Shared engine ---------- */
  var audio = new Audio();
  audio.preload = 'none';
  var current = null;     // { src, title, url, image, episode, duration }
  var speedIndex = Math.max(0, SPEEDS.indexOf(store.get('tc:speed') || 1));
  var lastSaved = 0;

  function emit() { document.dispatchEvent(new CustomEvent('tc:state')); }

  function load(ep, startAt) {
    if (!ep || !ep.src) return;
    if (!current || current.src !== ep.src) {
      if (current) savePosition(true);
      current = ep;
      audio.src = ep.src;
      audio.playbackRate = SPEEDS[speedIndex];
      var saved = store.get(posKey(ep.src));
      var at = typeof startAt === 'number' ? startAt : (saved && !saved.done ? saved.t : 0);
      if (at > 0) {
        var seekWhenReady = function () { try { audio.currentTime = at; } catch (e) {} audio.removeEventListener('loadedmetadata', seekWhenReady); };
        audio.addEventListener('loadedmetadata', seekWhenReady);
      }
      setMediaSession(ep);
      store.set('tc:now', ep);
    } else if (typeof startAt === 'number') {
      seek(startAt);
    }
  }
  function play(ep, startAt) {
    load(ep, startAt);
    var p = audio.play();
    if (p && p.catch) p.catch(function () {});
    Bar.show();
    emit();
  }
  function toggle(ep) {
    if (ep && (!current || current.src !== ep.src)) return play(ep);
    if (audio.paused) play(current); else audio.pause();
  }
  function seek(t) {
    if (!current) return;
    var d = audio.duration || (current.duration || 0);
    t = Math.max(0, d ? Math.min(t, d - 1) : t);
    if (audio.readyState > 0) audio.currentTime = t;
    else load(current, t);
    emit();
  }
  function skip(delta) { seek((audio.currentTime || 0) + delta); }
  function cycleSpeed() {
    speedIndex = (speedIndex + 1) % SPEEDS.length;
    audio.playbackRate = SPEEDS[speedIndex];
    store.set('tc:speed', SPEEDS[speedIndex]);
    emit();
  }
  function savePosition(force) {
    if (!current) return;
    var now = Date.now();
    if (!force && now - lastSaved < 4000) return;
    lastSaved = now;
    var d = audio.duration || current.duration || 0;
    var t = audio.currentTime || 0;
    store.set(posKey(current.src), { t: Math.floor(t), d: Math.floor(d), done: d > 0 && t > d - 30 });
  }
  function setMediaSession(ep) {
    if (!('mediaSession' in navigator)) return;
    try {
      navigator.mediaSession.metadata = new MediaMetadata({
        title: ep.title || '',
        artist: 'Tenkara Cast',
        album: ep.episode ? 'Episode ' + ep.episode : 'Tenkara Cast',
        artwork: ep.image ? [{ src: ep.image, sizes: '600x600', type: 'image/jpeg' }] : []
      });
      navigator.mediaSession.setActionHandler('play', function () { audio.play(); });
      navigator.mediaSession.setActionHandler('pause', function () { audio.pause(); });
      navigator.mediaSession.setActionHandler('seekbackward', function () { skip(-15); });
      navigator.mediaSession.setActionHandler('seekforward', function () { skip(30); });
      navigator.mediaSession.setActionHandler('seekto', function (e) { if (e.seekTime != null) seek(e.seekTime); });
    } catch (e) {}
  }

  ['play', 'pause', 'loadedmetadata', 'ratechange', 'waiting', 'playing', 'ended', 'error'].forEach(function (ev) {
    audio.addEventListener(ev, function () {
      if (ev === 'pause' || ev === 'ended') savePosition(true);
      emit();
    });
  });
  audio.addEventListener('timeupdate', function () {
    savePosition(false);
    document.dispatchEvent(new CustomEvent('tc:time'));
  });
  window.addEventListener('pagehide', function () { savePosition(true); });

  function epFrom(el) {
    var d = el.dataset;
    return {
      src: d.src, title: d.title, url: d.url, image: d.image,
      episode: d.episode, duration: parseInt(d.duration || '0', 10) || 0
    };
  }
  function isCurrent(src) { return current && current.src === src; }
  function isPlaying(src) { return isCurrent(src) && !audio.paused; }

  var Chapters = {
    links: null,
    mark: function (t) {
      if (!this.links) this.links = Array.prototype.slice.call(document.querySelectorAll('.pc-chapter[data-pc-seek]'));
      var active = -1;
      this.links.forEach(function (l, i) { if (t >= parseInt(l.dataset.pcSeek, 10)) active = i; });
      this.links.forEach(function (l, i) { l.classList.toggle('is-active', i === active && t >= 0); });
    }
  };

  var Transcript = {
    paras: null, last: -1,
    init: function () {
      var root = document.querySelector('[data-pc-transcript]');
      if (!root) return;
      this.root = root;
      this.paras = Array.prototype.slice.call(root.querySelectorAll('[data-t]'));
      var follow = root.querySelector('[data-pc-follow]');
      this.follow = follow;
      var search = root.querySelector('[data-pc-search]');
      var count = root.querySelector('[data-pc-count]');
      if (search) {
        var timer;
        search.addEventListener('input', function () {
          clearTimeout(timer);
          timer = setTimeout(function () { Transcript.search(search.value, count); }, 150);
        });
      }
    },
    search: function (q, count) {
      q = (q || '').trim().toLowerCase();
      var hits = 0;
      this.paras.forEach(function (p) {
        var text = p.querySelector('.pc-transcript__text');
        if (!text.dataset.orig) text.dataset.orig = text.textContent;
        var orig = text.dataset.orig;
        if (!q || q.length < 2) { text.textContent = orig; p.hidden = false; return; }
        var idx = orig.toLowerCase().indexOf(q);
        if (idx === -1) { p.hidden = true; text.textContent = orig; return; }
        p.hidden = false;
        var frag = document.createDocumentFragment(), lower = orig.toLowerCase(), pos = 0;
        while (idx !== -1) {
          frag.appendChild(document.createTextNode(orig.slice(pos, idx)));
          var mark = document.createElement('mark');
          mark.textContent = orig.slice(idx, idx + q.length);
          frag.appendChild(mark);
          hits++;
          pos = idx + q.length;
          idx = lower.indexOf(q, pos);
        }
        frag.appendChild(document.createTextNode(orig.slice(pos)));
        text.textContent = '';
        text.appendChild(frag);
      });
      if (count) count.textContent = q.length >= 2 ? (hits + (hits === 1 ? ' match' : ' matches')) : '';
    },
    mark: function (t) {
      if (!this.paras) return;
      var active = -1;
      for (var i = 0; i < this.paras.length; i++) { if (t >= +this.paras[i].dataset.t) active = i; else break; }
      if (t < 0) active = -1;
      if (active === this.last) return;
      if (this.last > -1 && this.paras[this.last]) this.paras[this.last].classList.remove('is-active');
      this.last = active;
      if (active > -1) {
        var p = this.paras[active];
        p.classList.add('is-active');
        if (this.follow && this.follow.checked && this.root.open) {
          var box = this.root.querySelector('.pc-transcript__body');
          if (box) box.scrollTo({ top: p.offsetTop - box.offsetTop - 24, behavior: 'smooth' });
        }
      }
    }
  };

  /* ---------- Large episode player ---------- */
  class PodcastPlayer extends HTMLElement {
    connectedCallback() {
      this.ep = epFrom(this);
      this.btn = this.querySelector('[data-pc-toggle]');
      this.range = this.querySelector('[data-pc-range]');
      this.elapsed = this.querySelector('[data-pc-elapsed]');
      this.remaining = this.querySelector('[data-pc-remaining]');
      this.speed = this.querySelector('[data-pc-speed]');
      this.resume = this.querySelector('[data-pc-resume]');
      this.dragging = false;

      var t = new URL(window.location.href).searchParams.get('t');
      this.deepLink = t ? parseTime(t) : null;

      this.btn && this.btn.addEventListener('click', () => {
        if (!isCurrent(this.ep.src) && this.deepLink != null) { play(this.ep, this.deepLink); this.deepLink = null; }
        else toggle(this.ep);
      });
      this.querySelectorAll('[data-pc-skip]').forEach((b) => b.addEventListener('click', () => {
        if (!isCurrent(this.ep.src)) load(this.ep);
        skip(parseInt(b.dataset.pcSkip, 10));
      }));
      this.speed && this.speed.addEventListener('click', cycleSpeed);
      if (this.range) {
        this.range.addEventListener('input', () => { this.dragging = true; this.paint(parseFloat(this.range.value)); });
        this.range.addEventListener('change', () => {
          this.dragging = false;
          if (!isCurrent(this.ep.src)) load(this.ep, parseFloat(this.range.value));
          else seek(parseFloat(this.range.value));
        });
      }
      if (this.resume) {
        var saved = store.get(posKey(this.ep.src));
        if (this.deepLink != null) {
          this.resume.textContent = 'Starts at ' + clock(this.deepLink);
          this.resume.hidden = false;
        } else if (saved && saved.t > 20 && !saved.done) {
          this.resume.textContent = 'Resume from ' + clock(saved.t);
          this.resume.hidden = false;
        } else if (saved && saved.done) {
          this.resume.textContent = 'Played';
          this.resume.hidden = false;
        }
      }
      this.onState = () => this.render();
      this.onTime = () => this.render();
      document.addEventListener('tc:state', this.onState);
      document.addEventListener('tc:time', this.onTime);
      this.render();
      PodcastPlayer.instances.push(this);
    }
    disconnectedCallback() {
      document.removeEventListener('tc:state', this.onState);
      document.removeEventListener('tc:time', this.onTime);
    }
    paint(t) {
      var d = (isCurrent(this.ep.src) && audio.duration) || this.ep.duration || 0;
      if (this.range) {
        this.range.max = d || 100;
        if (!this.dragging) this.range.value = t;
        this.range.style.setProperty('--pc-progress', d ? (t / d * 100) + '%' : '0%');
      }
      if (this.elapsed) this.elapsed.textContent = clock(t);
      if (this.remaining) this.remaining.textContent = d ? '-' + clock(d - t) : '';
    }
    render() {
      var mine = isCurrent(this.ep.src);
      var playing = mine && !audio.paused;
      this.classList.toggle('is-playing', playing);
      this.classList.toggle('is-active', mine);
      if (this.btn) this.btn.setAttribute('aria-label', playing ? 'Pause episode' : 'Play episode');
      if (this.speed) this.speed.textContent = SPEEDS[speedIndex] + '×';
      var t = mine ? (audio.currentTime || 0) : (this.deepLink != null ? this.deepLink : ((store.get(posKey(this.ep.src)) || {}).t || 0));
      if (mine && this.resume) this.resume.hidden = true;
      if (!this.dragging) this.paint(t);
      Chapters.mark(mine ? (audio.currentTime || 0) : -1);
      Transcript.mark(mine ? (audio.currentTime || 0) : -1);
    }
  }
  PodcastPlayer.instances = [];
  customElements.define('podcast-player', PodcastPlayer);

  /* ---------- Sticky mini-player ---------- */
  var Bar = {
    el: null,
    build: function () {
      if (this.el) return this.el;
      var el = document.createElement('div');
      el.className = 'pc-bar';
      el.setAttribute('role', 'region');
      el.setAttribute('aria-label', 'Audio player');
      el.innerHTML =
        '<div class="pc-bar__progress"><span data-bar-fill></span></div>' +
        '<div class="pc-bar__inner">' +
          '<button type="button" class="pc-iconbtn pc-bar__toggle" data-bar-toggle aria-label="Play">' + ICONS.play + ICONS.pause + '</button>' +
          '<div class="pc-bar__text"><span class="pc-bar__eyebrow" data-bar-eyebrow></span><a class="pc-bar__title" data-bar-title></a></div>' +
          '<span class="pc-bar__time" data-bar-time></span>' +
          '<button type="button" class="pc-iconbtn pc-bar__skip" data-bar-skip="-15" aria-label="Back 15 seconds">' + ICONS.back + '</button>' +
          '<button type="button" class="pc-iconbtn pc-bar__skip" data-bar-skip="30" aria-label="Forward 30 seconds">' + ICONS.fwd + '</button>' +
          '<button type="button" class="pc-speed pc-bar__speed" data-bar-speed aria-label="Playback speed"></button>' +
          '<button type="button" class="pc-iconbtn pc-bar__close" data-bar-close aria-label="Close player">' + ICONS.close + '</button>' +
        '</div>';
      document.body.appendChild(el);
      el.querySelector('[data-bar-toggle]').addEventListener('click', function () { toggle(); });
      el.querySelectorAll('[data-bar-skip]').forEach(function (b) { b.addEventListener('click', function () { skip(parseInt(b.dataset.barSkip, 10)); }); });
      el.querySelector('[data-bar-speed]').addEventListener('click', cycleSpeed);
      el.querySelector('[data-bar-close]').addEventListener('click', function () { audio.pause(); Bar.hide(true); });
      el.querySelector('.pc-bar__progress').addEventListener('click', function (e) {
        var r = this.getBoundingClientRect();
        if (audio.duration) seek((e.clientX - r.left) / r.width * audio.duration);
      });
      this.el = el;
      document.addEventListener('tc:state', function () { Bar.render(); });
      document.addEventListener('tc:time', function () { Bar.render(); });
      return el;
    },
    show: function () { this.build(); this.dismissed = false; this.render(); },
    hide: function (dismiss) { if (this.el) this.el.classList.remove('is-visible'); if (dismiss) this.dismissed = true; document.documentElement.classList.remove('pc-bar-open'); },
    render: function () {
      if (!this.el || !current) return;
      var el = this.el;
      // Hide while the page's own large player for this episode is on screen
      var mainVisible = PodcastPlayer.instances.some(function (p) { return isCurrent(p.ep.src) && p.inView; });
      var visible = !this.dismissed && !mainVisible && (!audio.paused || audio.currentTime > 0);
      el.classList.toggle('is-visible', visible);
      document.documentElement.classList.toggle('pc-bar-open', visible);
      el.classList.toggle('is-playing', !audio.paused);
      el.querySelector('[data-bar-toggle]').setAttribute('aria-label', audio.paused ? 'Play' : 'Pause');
      var title = el.querySelector('[data-bar-title]');
      title.textContent = current.title || '';
      if (current.url) title.href = current.url; else title.removeAttribute('href');
      el.querySelector('[data-bar-eyebrow]').textContent = current.episode ? 'Tenkara Cast · Episode ' + current.episode : 'Tenkara Cast';
      var d = audio.duration || current.duration || 0;
      el.querySelector('[data-bar-time]').textContent = clock(audio.currentTime) + (d ? ' / ' + clock(d) : '');
      el.querySelector('[data-bar-fill]').style.width = d ? (audio.currentTime / d * 100) + '%' : '0';
      el.querySelector('[data-bar-speed]').textContent = SPEEDS[speedIndex] + '×';
    }
  };

  // Track whether each large player is on screen (the bar takes over when it scrolls away)
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { e.target.inView = e.isIntersecting; });
      Bar.render();
    }, { threshold: 0.2 });
    var observe = function () { document.querySelectorAll('podcast-player').forEach(function (p) { io.observe(p); }); };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observe); else observe();
  }

  /* ---------- List play buttons, chapters, transcript timestamps ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-pc-play]');
    if (btn) {
      e.preventDefault();
      toggle(epFrom(btn));
      return;
    }
    var seekEl = e.target.closest('[data-pc-seek]');
    if (seekEl) {
      var player = document.querySelector('podcast-player');
      if (!player) return;
      e.preventDefault();
      var t = parseInt(seekEl.dataset.pcSeek, 10) || 0;
      play(player.ep, t);
      var url = new URL(window.location.href);
      url.searchParams.set('t', String(t));
      history.replaceState(null, '', url.toString());
    }
  });

  function renderListButtons() {
    document.querySelectorAll('[data-pc-play]').forEach(function (b) {
      var playing = isPlaying(b.dataset.src);
      b.classList.toggle('is-playing', playing);
      b.setAttribute('aria-pressed', playing ? 'true' : 'false');
      var label = b.querySelector('[data-pc-label]');
      if (label) label.textContent = playing ? (b.dataset.labelPause || 'Pause') : (b.dataset.labelPlay || 'Play');
    });
  }
  document.addEventListener('tc:state', renderListButtons);

  // "Played" / "In progress" markers on list rows
  function markProgress() {
    document.querySelectorAll('[data-pc-progress]').forEach(function (el) {
      var s = store.get(posKey(el.dataset.pcProgress));
      if (!s || !s.t) return;
      el.hidden = false;
      el.textContent = s.done ? 'Played' : clock(s.t) + ' in';
      el.classList.toggle('is-done', !!s.done);
    });
  }

  /* ---------- Episode library: filter, search, sort ---------- */
  class PodcastLibrary extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector('[data-pc-list]');
      this.items = Array.prototype.slice.call(this.querySelectorAll('[data-pc-item]'));
      this.empty = this.querySelector('[data-pc-empty]');
      this.countEl = this.querySelector('[data-pc-results]');
      this.more = this.querySelector('[data-pc-more]');
      this.pageSize = parseInt(this.dataset.pageSize || '20', 10);
      this.limit = this.pageSize;
      var params = new URL(window.location.href).searchParams;
      this.state = {
        format: params.get('format') || '',
        topic: params.get('topic') || this.dataset.initialTopic || '',
        q: '',
        sort: 'newest'
      };

      this.querySelectorAll('[data-pc-format]').forEach((b) => b.addEventListener('click', (e) => {
        e.preventDefault();
        this.state.format = b.dataset.pcFormat;
        this.limit = this.pageSize;
        this.update(true);
      }));
      var topic = this.querySelector('[data-pc-topic]');
      topic && topic.addEventListener('change', () => { this.state.topic = topic.value; this.limit = this.pageSize; this.update(true); });
      var sort = this.querySelector('[data-pc-sort]');
      sort && sort.addEventListener('change', () => { this.state.sort = sort.value; this.update(); });
      var q = this.querySelector('[data-pc-query]');
      var timer;
      q && q.addEventListener('input', () => {
        clearTimeout(timer);
        timer = setTimeout(() => { this.state.q = q.value.trim().toLowerCase(); this.limit = this.pageSize; this.update(); }, 150);
      });
      this.more && this.more.addEventListener('click', () => { this.limit += this.pageSize; this.update(); });
      if (topic && this.state.topic) topic.value = this.state.topic;
      this.update();
      markProgress();
    }
    update(pushUrl) {
      var s = this.state, shown = 0, matches = [];
      this.querySelectorAll('[data-pc-format]').forEach(function (b) {
        var on = b.dataset.pcFormat === s.format;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      var sorted = this.items.slice().sort(function (a, b) {
        var d = (+a.dataset.episode) - (+b.dataset.episode);
        return s.sort === 'oldest' ? d : -d;
      });
      sorted.forEach(function (it) {
        var ok = (!s.format || it.dataset.format === s.format) &&
                 (!s.topic || (',' + it.dataset.topics + ',').indexOf(',' + s.topic + ',') > -1) &&
                 (!s.q || it.dataset.search.indexOf(s.q) > -1);
        if (ok) matches.push(it);
        it.hidden = true;
      });
      // Re-order in the DOM, inserting year dividers
      var frag = document.createDocumentFragment(), lastYear = null, self = this;
      this.list.querySelectorAll('.pc-year').forEach(function (y) { y.remove(); });
      matches.forEach(function (it) {
        if (shown >= self.limit) return;
        if (s.sort !== 'relevance' && it.dataset.year !== lastYear) {
          lastYear = it.dataset.year;
          var y = document.createElement('li');
          y.className = 'pc-year';
          y.setAttribute('aria-hidden', 'true');
          y.textContent = lastYear;
          frag.appendChild(y);
        }
        it.hidden = false;
        frag.appendChild(it);
        shown++;
      });
      sorted.forEach(function (it) { if (it.hidden) frag.appendChild(it); });
      this.list.appendChild(frag);
      if (this.empty) this.empty.hidden = matches.length > 0;
      if (this.more) this.more.hidden = matches.length <= this.limit;
      if (this.countEl) this.countEl.textContent = matches.length === this.items.length ? matches.length + ' episodes' : matches.length + ' of ' + this.items.length + ' episodes';
      if (pushUrl && history.replaceState) {
        var url = new URL(window.location.href);
        s.format ? url.searchParams.set('format', s.format) : url.searchParams.delete('format');
        s.topic ? url.searchParams.set('topic', s.topic) : url.searchParams.delete('topic');
        history.replaceState(null, '', url.toString());
      }
    }
  }
  customElements.define('podcast-library', PodcastLibrary);
  /* ---------- Icons (used by the mini-player) ---------- */
  var ICONS = {
    play: '<svg class="pc-i pc-i--play" viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5.5v13a.6.6 0 0 0 .9.5l10.4-6.5a.6.6 0 0 0 0-1L8.9 5a.6.6 0 0 0-.9.5z" fill="currentColor"/></svg>',
    pause: '<svg class="pc-i pc-i--pause" viewBox="0 0 24 24" aria-hidden="true"><rect x="6.5" y="5" width="3.6" height="14" rx="1" fill="currentColor"/><rect x="13.9" y="5" width="3.6" height="14" rx="1" fill="currentColor"/></svg>',
    back: '<svg class="pc-i" viewBox="0 0 24 24" aria-hidden="true"><path d="M4.5 12a7.5 7.5 0 1 0 2.2-5.3M4.5 4v3.5H8" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/><text x="12" y="15.2" text-anchor="middle" font-size="7" font-family="inherit" fill="currentColor">15</text></svg>',
    fwd: '<svg class="pc-i" viewBox="0 0 24 24" aria-hidden="true"><path d="M19.5 12a7.5 7.5 0 1 1-2.2-5.3M19.5 4v3.5H16" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/><text x="12" y="15.2" text-anchor="middle" font-size="7" font-family="inherit" fill="currentColor">30</text></svg>',
    close: '<svg class="pc-i" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>'
  };

  // Hide the "/" separator on meta items that start a wrapped line (same as masterclass.js)
  function markLineStarts() {
    document.querySelectorAll('.mc-meta').forEach(function (list) {
      var prevTop = null;
      Array.prototype.forEach.call(list.children, function (item) {
        item.classList.remove('is-line-start');
        var top = item.offsetTop;
        if (prevTop !== null && top > prevTop + 2) item.classList.add('is-line-start');
        prevTop = top;
      });
    });
  }
  var resizeTimer;
  window.addEventListener('resize', function () { clearTimeout(resizeTimer); resizeTimer = setTimeout(markLineStarts, 100); });
  window.addEventListener('load', markLineStarts);

  function init() {
    markLineStarts();
    Transcript.init();
    markProgress();
    renderListButtons();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  window.TenkaraCast = { play: play, toggle: toggle, seek: seek, audio: audio, clock: clock };
})();
